<mat-dialog-content>
  <div class="row">{{ data.message }}</div>
  @if(data.progress$ | async; as progress) {
  <mat-progress-bar mode="determinate" color="accent" [value]="progress"></mat-progress-bar>
  }
</mat-dialog-content>